//add to cart count

document.addEventListener('DOMContentLoaded', async () => {
	// Function to update cart count
	const updateCartCount = async () => {
		try {
			const res = await fetch('/cart.json')
			const cart = await res.json()
			document.querySelectorAll('.cart-count').forEach((el) => {
				el.textContent = cart.item_count
			})
		} catch (error) {
			console.error('Error fetching cart data:', error)
		}
	}

	// Update cart count on page load
	updateCartCount()

	// Add-to-cart functionality
	const addToCartForms = document.querySelectorAll('form[action="/cart/add"]')
	addToCartForms.forEach((form) => {
		form.addEventListener('submit', async (event) => {
			// Prevent normal submission
			event.preventDefault()

			// Find the button inside the form using multiple classes
			const button = form.querySelector('[data-add-to-cart-btn]')

			// Change button text to 'Added'
			if (button) {
				button.textContent = 'Added'
			}

			// Submit form with AJAX
			await fetch('/cart/add', {
				method: 'post',
				body: new FormData(form)
			})

			// Update cart count
			updateCartCount()
		})
	})
})

// money filter script

var formatMoney = function (cents, format) {
	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}
	var value = ''
	var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	var formatString = format || this.money_format

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			cents = parts[1] ? decimal + parts[1] : ''

		return dollars + cents
	}

	switch (formatString.match(placeholderRegex)[1]) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0)
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
	}

	return formatString.replace(placeholderRegex, value)
}

function changeQuantity(formId, quantity) {
	var formQ = document.querySelector(formId)

	if (quantity == '+') {
		Number(formQ.value++)
	} else if (quantity == '-' && formQ.value > 1) {
		Number(formQ.value--)
	}
}
